import type { State } from './state'
import type { Mutation } from 'vuex'

import actionTypes from './actionTypes'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_CANCEL_TEXT](state, text: string): void {
    state.cancelText = text
  },

  [actionTypes.SET_CONFIRM_TEXT](state, text: string): void {
    state.confirmText = text
  },

  [actionTypes.SET_CONFIRM_MODAL_STATUS]: (state: State, status: boolean): void => {
    state.confirmModalActived = status
  },

  [actionTypes.SET_CONFIRM_MODAL_TEXT]: (state: State, text: string): void => {
    state.confirmModalText = text
  },

  [actionTypes.SET_CALLBACK_TO_CONFIRM_MODAL]: (
    state: State,
    callback: Function
  ): void => {
    state.callback = callback
  },

  [actionTypes.SET_USE_SINGLE_BUTTON_STATUS](state, status: boolean): void {
    state.useSingleButton = status
  },

  [actionTypes.SET_SINGLE_BUTTON_WIDTH](state: State, width: string): void {
    state.singleButtonWidth = width
  },
}

export default mutations
